import React from 'react';

import { StatisticsSpentTimeCite } from '../StatisticsSpentTimeCite/StatisticsSpentTimeCite';

import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import {
  calculateAverageSubjects,
  calculateMonthlySessions,
  getLineChartData,
  processAllUserSessions,
} from './StatisticsAllUtils';
import midleCountsSubjectsStudentsIcon from '../../../assets/img/midle-counts-subjects-students-icon.svg';
import {
  selectMaterials,
  selectNotebooks,
  selectStatisticsAll,
  selectStudents,
  selectTeachers,
} from '../../../redux/slices/statistics/additionalStatisticsSlice';
import { selectCurrentUser, selectSearchQuery } from '../../../redux/slices/statistics/statisticsSlice';
import './style.scss';
import { AllStatisticsStudents } from '../AllStatisticsStudents/AllStatisticsStudents';
import { MaterialsLineChartTwo } from '../MaterialsLineChart/MaterialsLineChart';
import { allStatisticsUsers } from '../statisticsParentUtils';
import { StatisticsSquareMidle } from '../StatisticsSquareMidle/StatisticsSquareMidle';
import { StatisticsWorkMaterials } from '../StatisticsWorkMaterials/StatisticsWorkMaterials';
import { StatisticsWorkMaterialsTwo } from '../StatisticsWorkMaterialsTwo/StatisticsWorkMaterialsTwo';

export const StatisticsAll = () => {
  const { t } = useTranslation();
  const currentSearchQuery = useSelector(selectSearchQuery);
  const currentUser = useSelector(selectCurrentUser);
  const students = useSelector(selectStudents);
  const teachers = useSelector(selectTeachers);
  const notebooks = useSelector(selectNotebooks);
  const materials = useSelector(selectMaterials);
  const statisticsAllState = useSelector(selectStatisticsAll);

  return (
    <div className="statistics-teacher statistics-content-block">
      {currentSearchQuery && currentUser && students && teachers && notebooks && materials && statisticsAllState && (
        <div className="statistics-content-block-top">
          <h2>{t('General statistics')}</h2>

          <div className="statistics-content-block-row">
            <AllStatisticsStudents
              parentObj={allStatisticsUsers(students, statisticsAllState.FindingStudentsSite)}
              text={'Statistics on students'}
              hidenAgesRow={false}
              textTop={'studentsStatisticsAll'}
              totalCount={students.length}
            />

            <StatisticsWorkMaterialsTwo
              obj={calculateMonthlySessions(students)}
              text={'average time students spent on the site'}
              textTop={'time-numb'}
              allUsers={students}
            />
          </div>

          <div className="statistics-content-block-row">
            <AllStatisticsStudents
              parentObj={allStatisticsUsers(teachers, statisticsAllState.FindingTeachersSite)}
              text={'Statistics on students'}
              hidenAgesRow={true}
              textTop={'teachersStatisticsAll'}
              totalCount={teachers.length}
            />
            <StatisticsWorkMaterialsTwo
              obj={calculateMonthlySessions(teachers)}
              text={'average time teachers spend on the website'}
              textTop={'time-numb'}
              allUsers={teachers}
            />
          </div>

          <div className="statistics-content-block-row">
            <StatisticsSpentTimeCite
              item={processAllUserSessions(students)}
              title={'time-numb'}
              subTitle={'closing time on the websites of all schools'}
            />

            <StatisticsSpentTimeCite
              item={processAllUserSessions(teachers)}
              title={'time-numb'}
              subTitle={'closing time on the websites of all schools'}
            />
          </div>

          <div className="statistics-content-block-row">
            <MaterialsLineChartTwo
              data={getLineChartData(statisticsAllState.AllMaterials).data}
              totalCount={getLineChartData(statisticsAllState.AllMaterials).total}
              text={'total number of educational materials'}
              textTop={'of materials'}
            />

            <MaterialsLineChartTwo
              data={getLineChartData(statisticsAllState.AllCreateLinksMaterials).data}
              totalCount={getLineChartData(statisticsAllState.AllCreateLinksMaterials).total}
              text="number of created links to materials"
              textTop="links"
            />
          </div>

          <div className="statistics-content-block-row">
            <StatisticsSquareMidle
              icon={midleCountsSubjectsStudentsIcon}
              count={calculateAverageSubjects(students)}
              text={'average quantity students items'}
            />
          </div>
        </div>
      )}
    </div>
  );
};
